export default __webpack_public_path__ + "static/media/house.019e6db4.png";